/*
 * @Author: WUJUN
 * @Date: 2019-07-11 11:35:26
 * @LastEditTime: 2019-10-31 14:19:04
 * @LastEditors: WUJUN
 * @Description: 批量注册自定义 全局组件
 */

import header from './base/header';
import navBar from './base/navBar';
import topBtn from './base/topBtn';
import FtCloseIcon from './base/ftCloseIcon';
import FtAddress from './base/ftAddress';
import FtSwitch from './base/ftSwitch';
import FtInput from './base/ftInput';
import FtNotFound from './base/ftNotFound';
const components = [header, navBar, topBtn, FtCloseIcon, FtAddress, FtSwitch, FtInput, FtNotFound];

const install = function(Vue, opts = {}) {
  components.forEach((component) => {
    Vue.component(component.name, component);
  });
};
export default install;



// WEBPACK FOOTER //
// src/components/ftComponents.js